import React, { useState, useContext, useEffect } from "react";
import { PortalContext } from "../../../context/Provider";
import { setPasoMultiTab } from "../../../context/Actions/multiTab/multiTab";
import "./MultiTabPerfil.css";
import { logoutRegistro } from "../../../context/Actions/registro/logoutRegistro";

const MultiTabPerfil = ({ tabs, estilos }) => {
  const { multiTabState, multiTabDispatch, registroDispatch } =
    useContext(PortalContext);
  const [numActivo, setNumActivo] = useState(0);
  

  const activarPestania = (num) => {
    setPasoMultiTab(num)(multiTabDispatch);
  };

  useEffect(() => {
    logoutRegistro()(registroDispatch); // reseteo errores cuando cambio de pestaña
    if (multiTabState.multiTab === undefined) setNumActivo(0);
    else setNumActivo(multiTabState.multiTab.paso > 1 ? 0 : multiTabState.multiTab.paso);
    //eslint-disable-next-line
  }, [multiTabState]);

  return (
    <React.Fragment>
      <div className={`${estilos.pestaniasContenedor} noSeleccionable`}>
        {Array.isArray(tabs) &&
          tabs.length > 0 &&
          tabs.map((item, index) => {
            return (
              <div
                className={`${estilos.pestanias}  ${
                  numActivo === index ? estilos.bgc : estilos.usarHover
                }`}
                onClick={() => activarPestania(index)}
                key={index}
              >
                {numActivo === index && (
                  <div className={`${estilos.flecha}  ${estilos.bgc}`}></div>
                )}
                <div className={`${estilos.flechaConTitulo}`}>
                  <span
                    className={`ptur-multiTabPerfil-textos ${
                      numActivo === index
                        ? estilos.colorClaro
                        : estilos.colorOscuro
                    } ${
                      item.nombre === "Datos personales"
                        ? estilos.datosPersonales
                        : estilos.obraSoc
                    }`}
                  >
                    {item.nombre}
                  </span>
                </div>
              </div>
            );
          })}
      </div>
      {Array.isArray(tabs) &&
        tabs.length > 0 &&
        tabs.map((item, index) => {
          return (
            item.carpeta !== "" &&
            item.componente !== "" &&
            numActivo === index &&
            React.createElement(
              require(`../` + item.carpeta + "/" + item.componente).default,
              item.params
            )
          );
        })}
    </React.Fragment>
  );
};
export default MultiTabPerfil;
